//TODO: switch mode

export * from 'seamless-immutable';
export default from 'seamless-immutable';

//force production mode
// export * from 'seamless-immutable/seamless-immutable.production.min';
// export default from 'seamless-immutable/seamless-immutable.production.min';